import React, { useContext, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { defineMessages, useIntl } from 'react-intl';
import { parse, stringify } from '../../../utils/UrlUtil';
import { AccountContext } from '../../../components/AccountContext';
import useSubscriptionExpiredRestrictions from '../../../hooks/useSubscriptionExpiredRestrictions';

const messages = defineMessages({
  add: { id: 'menu.add_survey_template', defaultMessage: 'Add Survey Template' },
});

const SurveyTempListHeader = () => {
  const location = useLocation();
  const history = useHistory();
  const { formatMessage } = useIntl();
  const params = parse(location.search);
  const currentAccount = useContext(AccountContext);

  const [filter, setFilter] = useState({ ...params.filter });
  const { subscriptionIsExpired } = useSubscriptionExpiredRestrictions();

  /**
   * Get old URL and:
   * - parse query params
   * - merge new param values
   * - stringify query params
   * - push new url
   */
  const onQueryVariableChange = () => {
    const params = parse(location.search);

    // build the filter
    const newFilter = {
      ...params.filter,
      ...filter,
    };

    const search = stringify({
      ...params,
      filter: newFilter,
    });

    // update url with the new search, keep the rest of the values
    history.push({
      ...location,
      search,
    });
  };

  /**
   * Update the filter Query.
   */
  const onChangeQueryText = (event) => {
    const updatedFilter = {
      ...filter,
      query: event.currentTarget.value,
    };

    setFilter(updatedFilter);
  };

  return (
    <div className="p-grid">
      <div className="p-col">
        <div className="p-inputgroup">
          <InputText
            value={filter.query}
            onChange={onChangeQueryText}
            onKeyPress={(event) => {
              if (event.key === 'Enter') {
                onQueryVariableChange();
              }
            }}
          />
          <Button
            icon="pi pi-search"
            // For search we have a search button.
            // The state is already updated. We just upate the url
            onClick={onQueryVariableChange}
          />
        </div>
      </div>
      <div className="p-col align-right">
        <Button
          label={formatMessage(messages.add)}
          icon="fa fa-plus"
          disabled={subscriptionIsExpired}
          onClick={() => history.push(`/accounts/${currentAccount}/surveys/templates/new`)}
        />
      </div>
    </div>
  );
};

export default SurveyTempListHeader;
